module.exports = __webpack_public_path__ + "img/p_mx.aa637e83.svg";